import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  "f-w-600": "",
  "m-tb-0": ""
}
const _hoisted_2 = {
  "f-w-600": "",
  "m-tb-0": ""
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_table, {
      size: "medium",
      stripe: "",
      data: _ctx.biddings,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "#ID",
          width: "60"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tooltip, {
              content: scope.row._id
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("i", {
                  "f-w-700": "",
                  class: "el-icon-money"
                }, null, -1)
              ]))]),
              _: 1
            }, 8, ["content"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "Startup",
          label: "Startup"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("h4", _hoisted_1, _toDisplayString(scope.row.business.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "Talent",
          label: "Talent"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("h4", _hoisted_2, [
              _createTextVNode(_toDisplayString(scope.row.talent.firstName) + " ", 1),
              (scope.row.talent.lastName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(scope.row.talent.lastName.charAt(0)), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "compensation",
          label: "Compensation",
          width: "180"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              size: "mini",
              round: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(scope.row.compensationTypes.join(", "))), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "compensationAmount",
          label: "Amount",
          width: "180"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, [
              (scope.row.compensationTypes.includes('cash'))
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(scope.row.currency) + " " + _toDisplayString(scope.row.cash), 1))
                : _createCommentVNode("", true),
              (scope.row.compensationTypes.includes('equity'))
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(scope.row.equity) + " % ", 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "status",
          label: "Status",
          width: "180"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              size: "mini",
              round: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(scope.row.status)), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "Actions",
          width: "120"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: "el-icon-more",
              "is-borderless": "",
              circle: "",
              plain: "",
              size: "small"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}